import React, { useEffect, useState } from 'react'
import moment from 'moment'

const withEffects = WrappedComponent => {
  return props => {
    const {
      refetch // via withQuery
    } = props

    // local state to trigger refetch cycles
    const [lastRefetchTime, setLastRefetchTime] = useState(moment())

    // every 10 minutes, refetch the GraphQL query to get updated room meetings
    useEffect(() => {
      if (!refetch) return

      const timer = setTimeout(async () => {
        try {
          await refetch()
        } catch (error) {
          // Silently handle errors - the query error handler will deal with them
          console.warn('Room meetings refetch failed:', error)
        }
        // Trigger the next cycle by updating state
        setLastRefetchTime(moment())
      }, 10 * 60 * 1000) // 10 minutes in milliseconds

      // clean up when component unmounts
      return () => clearTimeout(timer)
    }, [refetch, lastRefetchTime])

    return <WrappedComponent {...props} />
  }
}

export default withEffects
